export function extractErrorMessage(error, fallback = 'Wystąpił niespodziewany błąd.') {
    if (error?.response?.data) {
        const data = error.response.data

        if (data.message) {
            return data.message
        }

        if (data.errors && typeof data.errors === 'object') {
            const errorMessages = Object.values(data.errors)
                .flat()
                .filter(Boolean)

            if (errorMessages.length > 0) {
                return errorMessages.join('\n')
            }
        }

        if (data.error) {
            return data.error
        }
    }

    if (error?.message) {
        if (error.message.includes('Network Error')) {
            return 'Błąd połączenia z serwerem. Sprawdź połączenie internetowe.'
        }
        if (error.message.includes('timeout')) {
            return 'Przekroczono czas oczekiwania na odpowiedź serwera.'
        }
    }

    return fallback
}

// Toast helper functions
import { useToast } from "vue-toastification"

export function showErrorToast(error, fallback) {
    const toast = useToast()
    const message = extractErrorMessage(error, fallback)
    toast.error(message)
}

export function showSuccessToast(message) {
    const toast = useToast()
    toast.success(message)
}

export function showInfoToast(message) {
    const toast = useToast()
    toast.info(message)
}

export function showWarningToast(message) {
    const toast = useToast()
    toast.warning(message)
}
